// extracted by mini-css-extract-plugin
export var header = "_ur-1";
export var maskBottom = "_ur-6";
export var maskMiddle = "_ur-7";
export var maskTop = "_ur-5";
export var root = "_ur-0";
export var scrollDownButton = "_ur-3";
export var scrollDownButtonHidden = "_ur-4";
export var viewport = "_ur-2";